import * as queries from 'lib/graphql/queries';
import yotpo from 'lib/yotpo';
import storefront from 'lib/storefront';
import { generateNewDocumentTitleOnShadeChange } from 'utils/general';

/**
 * @info
 *
 * *The "store/product" directory*
 * This "store" directory declares each of the Vuex
 * modules that all together power the site. Here, we have the
 * Vuex store module that sits behind product functionality.
 *
 * *This file*
 * This file outlines "actions". Actions are functions that
 * include logic that, when ready, commits a mutation to the
 * application state. Whereas mutations must be synchronous,
 * actions return a promise and can include asynchronous
 * logical sequences.
 */

export default {
  updateVariant({ commit }, payload) {
    commit('setVariant', payload);
  },
  updateProductStatic({ commit }, product) {
    commit('setStatic', true);
    commit('setNewProduct', product);
    commit('setVariant', product.variants[0]);
    commit('setVariantImage', product.featuredImage);
  },
  updateProduct({ commit, state, dispatch }, payload) {
    if (state.isStatic) return;
    commit('setLoading', true);
    return storefront
      .request(queries.product, { handle: payload })
      .then((response) => {
        if (response.product) {
          commit('setNewProduct', response.product);
          dispatch('updateVariantData', response.product.variants.edges);
        } else {
          console.error('Could not find product in Storefront API', payload);
        }
        commit('setLoading', false);
        return Promise.resolve(response);
      })
      .catch((error) => {
        console.error(error);
        commit('setLoading', false);
      });
  },
  updateReviews({ commit, rootState }, { productId, page = 1 }) {
    const { isMobile } = rootState.global;
    const reviewsPerPage = isMobile ? 5 : 10;
    yotpo
      .getReviews(productId, page, reviewsPerPage)
      .then(({ responseText }) => {
        const body = JSON.parse(responseText).response;
        commit('setReviews', body);
      });
  },
  postReview({ commit }, payload) {
    return yotpo.postReview(payload).then(({ code, responseText }) => {
      commit('setReviewResponse', code);
      return Promise.resolve(responseText);
    });
  },
  voteReview({ commit }, payload) {
    return yotpo.voteReview(payload);
  },
  undoVoteReview({ commit }, payload) {
    return yotpo.undoVoteReview(payload);
  },
  updateVariantData({ commit, state }, data) {
    if (data.length > 1 && state.variant.option) {
      data.forEach((variant) => {
        if (variant.node.title === state.variant.option) {
          commit('setVariant', variant.node);
          variant.node.image && commit('setVariantImage', variant.node.image);
          commit('setPrice', {
            price: variant.node.price?.amount,
            compareAtPrice: variant.node.compareAtPrice?.amount,
          });
          commit('setAvailable', variant.node.availableForSale);
        }
      });
    } else {
      const variant = data.node || data[0].node;
      commit('setVariant', variant);
      variant.image && commit('setVariantImage', variant.image);
      commit('setPrice', {
        price: variant.price?.amount,
        compareAtPrice: variant.compareAtPrice?.amount,
      });
      commit('setAvailable', variant.availableForSale);
    }
  },
  updateProductAsNewPage(
    { commit, state, dispatch },
    { previousColor, shade, handle },
  ) {
    return dispatch('updateProduct', handle).then(({ product }) => {
      window.history.replaceState(
        {},
        generateNewDocumentTitleOnShadeChange(shade, previousColor),
        `${Shopify.routes.root}products/${handle}`,
      );
      document.title = generateNewDocumentTitleOnShadeChange(
        shade,
        previousColor,
      );
      return Promise.resolve(true);
    });
  },
  updateActiveImage({ commit }, index) {
    commit('setActiveImage', index);
  },
  updateActiveCategory({ commit }, category) {
    commit('setActiveCategory', category);
  },
};
